import Vue from "vue";
import Vuex from "vuex";
import tabs from "./tabs/tabs"
import viewTabs from "./view-tabs/view-tabs"
import docs from "./docs/docs"
import userInfo from "./userInfo/userInfo"
import widget from "./widget/widget"
import wOptions from "./widget/w-options"
Vue.use(Vuex);

const store = new Vuex.Store({
    state: {

    },
    mutations: {
        
    },
    modules: {
        tabs,
        userInfo,
        docs,
        viewTabs,
        widget,
        wOptions
    },
    strict: false
});



export default store;
